import { useNavigate, useParams } from "react-router-dom";
import Axios from "axios";
import { getDomain } from "../../Utilities/utils";
import { TRANSFER_DATA_API_ENDPOINT } from "../../PersonalAccident/apiConfig";
import { useEffect, useState } from "react";
import { POLICY_STATUS } from "../PaymentOptionsPage/usePaymentOptions";
import Swal from "sweetalert2";
import { THANK_YOU_PAGE_ROUTE } from "../routes";

const usePaymentPageForCustomer = () => {
  const { transferDataId } = useParams();

  const [clickedPayHere, setClickedPayHere] = useState(false);
  const [transferData, setTransferData] = useState({});
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    getTransferData();
  }, [transferDataId]);

  const payHere = () => {
    // If payment is already done, show success dialog
    if (transferData?.policy_status === POLICY_STATUS.PAYMENT_SUCCESS) {
      Swal.fire({
        icon: "success",
        title: "Payment Verified",
        confirmButtonColor: "#0d409b",
        text: "Your payment has already been made. Please contact your agent for further details.",
        confirmButtonText: "OK",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate(THANK_YOU_PAGE_ROUTE);
        }
      });
      return;
    }

    setClickedPayHere(true);
    // Get payment url from transfer data and redirect to that url
    const paymentUrl = transferData?.paymentUrl?.replace("posp", "customer");
    if (!paymentUrl) {
      alert("Something went wrong. Please try again later.");
      return;
    }
    window.location.href = paymentUrl;
  };

  const getTransferData = async () => {
    setLoading(true);

    try {
      // Call transfer data api
      const domain = getDomain();
      const response = await Axios.get(
        `${domain}${TRANSFER_DATA_API_ENDPOINT}/${transferDataId}`
      );
      console.log("response: ", response);
      if (response?.status !== 200) return;
      setTransferData(response?.data);
      setLoading(false);
    } catch (error) {
      console.log("error: ", error);
      setLoading(false);
    }
  };
  return { loading, transferData, clickedPayHere, payHere };
};

export default usePaymentPageForCustomer;
